import { stringify, type ParsedUrlQuery } from 'querystring';
import { safeFormatClientDate } from 'shared/util/datetime-fns';
import type { Filters } from '@/interfaces';
import { queryParamToString } from 'shared/util/queryParamConverters';
import {
    escapeQueryParams,
    queryParamToDate,
    queryParamToDayOfWeekEnd,
    queryParamToDayOfWeekStart,
    queryParamToDaysAheadEnd,
    queryParamToDaysAheadStart,
    queryParamToRooms,
    removeEmptyValues,
    roomsToQueryParams,
} from './queryParamConverters';
import { adjustInvalidDates } from './invalidDates';

const queryParamsToFilters = (query: ParsedUrlQuery): Partial<Filters> =>
    removeEmptyValues({
        hotel: queryParamToString(query.hotel),
        checkInDate:
            queryParamToDate(query.checkInDate) ??
            queryParamToDaysAheadStart(query.daysAhead) ??
            queryParamToDayOfWeekStart(query.dayOfWeek),
        checkOutDate:
            queryParamToDate(query.checkOutDate) ??
            queryParamToDaysAheadEnd(query.daysAhead, query.nights) ??
            queryParamToDayOfWeekEnd(query.dayOfWeek, query.nights),
        rooms: queryParamToRooms(query.rooms),
        utm_source: queryParamToString(query.utm_source),
        utm_medium: queryParamToString(query.utm_medium),
        utm_campaign: queryParamToString(query.utm_campaign),
        utm_term: queryParamToString(query.utm_term),
        utm_content: queryParamToString(query.utm_content),
    });

export const browserQueryParamsToHotelPageFilters = (query: ParsedUrlQuery): Partial<Filters> =>
    adjustInvalidDates(queryParamsToFilters(escapeQueryParams(query)));

export const filtersToHotelPageBrowserQueryParams = (filters: Partial<Filters>, keepTracking = false): string =>
    stringify(
        removeEmptyValues({
            checkInDate: safeFormatClientDate(filters.checkInDate, undefined),
            checkOutDate: safeFormatClientDate(filters.checkOutDate, undefined),
            rooms: roomsToQueryParams(filters.rooms),
            utm_source: keepTracking && filters.utm_source,
            utm_medium: keepTracking && filters.utm_medium,
            utm_campaign: keepTracking && filters.utm_campaign,
            utm_term: keepTracking && filters.utm_term,
            utm_content: keepTracking && filters.utm_content,
        }),
    );
